import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Stack } from '../components/ui';

/**
 * Landing spot for OAuth redirects (D1). The backend puts tokens in the URL
 * fragment (never sent to servers); we lift them into the normal auth flow
 * and scrub the URL so tokens don't linger in history.
 */
export function AuthCallbackPage(): JSX.Element {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token');
    window.history.replaceState(null, '', window.location.pathname);

    if (!token) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }
    void loginWithToken(token);
  }, [loginWithToken, navigate]);

  return (
    <Stack gap={4} className="mx-auto max-w-md text-center">
      <h1 className="text-2xl font-semibold text-foreground">Completing sign-in…</h1>
      <p className="text-sm text-muted-foreground">Hang tight while we finish connecting your account.</p>
    </Stack>
  );
}
